import { render, staticRenderFns } from "./RequestInformation.vue?vue&type=template&id=00ec89f9&scoped=true"
import script from "./RequestInformation.vue?vue&type=script&lang=js"
export * from "./RequestInformation.vue?vue&type=script&lang=js"
import style0 from "./RequestInformation.vue?vue&type=style&index=0&id=00ec89f9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ec89f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00ec89f9')) {
      api.createRecord('00ec89f9', component.options)
    } else {
      api.reload('00ec89f9', component.options)
    }
    module.hot.accept("./RequestInformation.vue?vue&type=template&id=00ec89f9&scoped=true", function () {
      api.rerender('00ec89f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/sections/RequestInformation.vue"
export default component.exports